var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61084 10.9773L1.30542 12.2752L0 10.9773L1.30542 9.6793L2.61084 10.9773ZM34 25.6641C34 26.151 33.8055 26.618 33.4592 26.9623C33.1129 27.3066 32.6433 27.5 32.1536 27.5C31.6639 27.5 31.1942 27.3066 30.848 26.9623C30.5017 26.618 30.3072 26.151 30.3072 25.6641H34ZM10.5375 21.4545L1.30542 12.2752L3.91626 9.6793L13.1484 18.8586L10.5375 21.4545ZM1.30542 9.6793L10.5375 0.5L13.1484 3.09591L3.91626 12.2752L1.30542 9.6793ZM2.61084 9.14139H21.0751V12.8131H2.61084V9.14139ZM34 21.9924V25.6641H30.3072V21.9924H34ZM21.0751 9.14139C24.503 9.14139 27.7905 10.4953 30.2144 12.9054C32.6383 15.3154 34 18.5841 34 21.9924H30.3072C30.3072 19.5579 29.3345 17.2231 27.6031 15.5017C25.8718 13.7802 23.5236 12.8131 21.0751 12.8131V9.14139Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.79af0d70f1dfca8b59cb8ef0997ea4c6.svg";
export { ForwardRef as ReactComponent };